import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useEmailsStore } from '~/stores/emails'
import { useOrganizationsStore } from '~/stores/organizations'

export async function useEmails() {
  const emailsStore = useEmailsStore()
  const organizationsStore = useOrganizationsStore()

  const loading = computed(() => emailsStore.loading || organizationsStore.loading)
  const error = computed(() => emailsStore.error || organizationsStore.error)

  const {items: emails} = storeToRefs(emailsStore)
  const {items: organizations} = storeToRefs(organizationsStore)

  return {
    error,
    loading,
    emails,
    organizations,
    emailsStore,
    organizationsStore
  }
}
